<section class="init-screen d-none" id="pos-login-container">
  <pos-header [isLogoHeader]="true" [headerClass]="'init-header'"></pos-header>
  <div class="init-body">
    <div class="init-card">
      <div class="init-card-header">Select loan application</div>
      <div id="loan-list" class="init-card-body">
        <ul class="loan-list">
          <li *ngFor="let loan of loans; let i=index" [ngClass]="loan.statusClass" (click)="proceed(loan)">
            <span class="icon">
              <svg class="nav-icon">
                <use xlink:href=""
                     [xlinkHref]="loan.LoanPurposeType === 'Refinance' ? '#icon-refinance-property' : '#icon-purchase-property'"></use>
              </svg>
            </span>
            <div class="details">
              <span [id]="loan.LoanPurposeType +'-'+ loan.PercentComplete"
                    class="type">{{loan.LoanPurposeType}}</span>
              <span class="number">Application #{{loan.LoanId}}</span>
              <span class="address">Updated {{loan.updatedAt | timeAgo}}</span>
            </div>

            <span *ngIf="loan.presentInExcludedStage; else others" class="status">
              <ng-container *ngIf="loan.CurrentStage?.StageId === stagesIds['SUSPENDED']">
                <svg><use xlink:href="#icon-deactivate-denied-block"></use></svg>
              </ng-container>
              <ng-container *ngIf="loan.CurrentStage?.StageId === stagesIds['ADVERSE']">
                <svg><use xlink:href="#error-thick"></use></svg>
              </ng-container>
          <!--    <ng-container *ngIf="loan.CurrentStage?.StageId === stagesIds['LOAN_FUNDED']">
                <svg><use xlink:href="#dollar-money-funded"></use></svg>
              </ng-container>-->
              <ng-container
                *ngIf="loan.CurrentStage?.StageId === stagesIds['LOAN_FUNDED'] || loan.CurrentStage?.StageId === stagesIds['DOCS_SIGNED'] || loan.CurrentStage?.StageId ===  stagesIds['BROKER_CHECK_RECEIVED']">
                <svg><use xlink:href="#file-completed-closed"></use></svg>
              </ng-container>
              {{loan.CurrentStage.PipelineId === fundedPipeline?.id ? 'Loan Funded' : loan.stageName}}
              <span class="tooltip">
                Your loan is marked as {{loan.CurrentStage.PipelineId === fundedPipeline?.id ? 'Loan Funded' : loan.stageName}}{{loan.CurrentStage.AdverseReason ? ' due to ' + (loan.CurrentStage.AdverseReason | enumLookup : 'ADVERSE_REASON') : ''}}
                .
                <ng-container *ngIf="loan.LoanOfficer">
                  <br>For more information please
                  <ng-container *ngIf="loan.LoanOfficer.phone; else phoneEmpty">
                    call {{loan.LoanOfficer.name || 'Loan Officer'}}
                    at <span>{{loan.LoanOfficer.phone | phone}}</span><br>or email
                  </ng-container>
                  <ng-template #phoneEmpty>email {{loan.LoanOfficer.name || 'Loan Officer'}}</ng-template>
                  at <a href="#">{{loan.LoanOfficer.email}}</a>
                </ng-container>
              </span>
            </span>

            <ng-template #others>
              <span *ngIf="loan.appSubmissionDate" class="status">
                Application Submitted
              </span>

              <div *ngIf="!loan.appSubmissionDate" class="c100 small" [ngClass]="'p'+loan.PercentComplete">
                <span>{{loan.PercentComplete}}%</span>
                <div class="slice">
                  <div class="bar"></div>
                  <div class="fill"></div>
                </div>
              </div>
            </ng-template>

          </li>
        </ul>
      </div>
      <div *ngIf="noActiveLoan" class="init-card-footer">
        <button class="btn btn-outline-primary" (click)="createNewLoan()">
          <svg class="fill-current">
            <use xlink:href="#plus"></use>
          </svg>
          New Application
        </button>
      </div>

    </div>
    <app-logout></app-logout>
  </div>
  <app-footer></app-footer>
</section>
